var React = require('react');

function Heart20x20 (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Size=20x20, Invert=off"},React.createElement("path",{"id":"Vector","d":"M16.809 3.457a4.656 4.656 0 011.338 1.512 4.831 4.831 0 01.314 3.98 4.72 4.72 0 01-1.083 1.716l-6.275 6.306a1.707 1.707 0 01-2.477 0l-5.969-6.306a4.948 4.948 0 01-.595-6.172 4.62 4.62 0 011.471-1.375A4.448 4.448 0 017.399 2.8a4.558 4.558 0 011.665 1.116l.954.991.875-.837a4.596 4.596 0 015.916-.613v0z","stroke":"currentColor","strokeMiterlimit":"10"})));
}

Heart20x20.defaultProps = {"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none"};

module.exports = Heart20x20;

Heart20x20.default = Heart20x20;
